import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'cream' | 'cream-dark' | 'sage-light' | 'sage' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'cream'
}: SectionProps) {
  const bgClasses = {
    cream: 'bg-cream',
    'cream-dark': 'bg-cream-dark',
    'sage-light': 'bg-sage-50',
    sage: 'bg-sage-700 text-white',
    white: 'bg-white'
  };
  return <section id={id} className={`py-20 md:py-32 overflow-hidden ${bgClasses[bg]} ${className}`} data-id="element-190">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-191">
        {children}
      </motion.div>
    </section>;
}